import React, { Component } from 'react'

import { Button } from './Button-styled'

export default class ButtonComponent extends Component {
  state = {
    clicked: false,
  }

  buttonClicked = () => {
    if (this.props.onClick) {
      if (this.props.animateOnClick) {
        this.animatedClick()
      } else {
        this.props.onClick()
      }
    }
  }

  animatedClick = () => {
    if (!this.state.clicked) {
      this.setState(
        {
          clicked: true,
        },
        () => {
          setTimeout(() => {
            this.props.onClick()
          }, 400)
        },
      )
    }
  }

  render() {
    const { clicked } = this.state
    const {
      title,
      type = 'main',
      fullWidth = false,
      large = false,
      animateOnClick = false,
    } = this.props
    return (
      <Button
        type={type}
        fullWidth={fullWidth}
        large={large}
        onClick={this.buttonClicked}
        clicked={clicked}
        animateOnClick={animateOnClick}
      >
        {title}
      </Button>
    )
  }
}



// WEBPACK FOOTER //
// ./src/component/_presentational/Button/Button.jsx